//src//dataTypes/claimManagement.types.ts
export type PatientAddress = {
  street: string
  city: string
  state: string
  zipCode: string
  country: string
}

export enum ProcedureStatus {
  Unclaimed = 'Unclaimed',
  Claimed = 'Claimed',
}

export type Procedure = {
  procedureName: string
  procedureCode: string
  procedureDate: string
  provider: string
  providerFirstName: string
  providerLastName: string
  coverage: string
  amount: number
  status: ProcedureStatus
}

export type ClaimDetail = {
  id: string
  date: string
  patientName: string
  patientId: string
  subscriberName: string
  subscriberId: string
  insuranceProvider: string
  providerName: string
  providerId: string
  clinicName: string
  groupName: string
  groupId: string
  validity: string
  procedureName?: string
  procedureCode?: string
  amount?: number
}

export type Attachment = {
  itemNo: number
  item: string
  formatType: string
  orientation: string
  dateTaken: string
  file?: File
  fileName?: string
  isEditing?: boolean
}

export type Note = {
  author: string
  content: string
  date: string
  relatedAttachmentItemNo?: number
}

export type ClaimAttachment = {
  claimId: string
  itemNo: number
  item: string
  formatType: string
  orientation: string
  dateTaken: string
  fileName?: string
  isEditing?: boolean
  notes: Note[]
}

export type Claim = {
  id: string
  date: string
  patientId: string
  patientName: string
  claimForm: string
  claimType: ClaimType
  patientAddress: PatientAddress
  patientSubscriber: {
    subscriberId: string
    name: string
    relationship: string
    contact: string
  }
  clinicName: string
  providerName: string
  insuranceProviderId: string
  insuranceProvider: string
  groupName: string
  groupId: string
  claimAmount: number
  amountPaid: number
  status: ClaimStatus
  notes?: string
  photo: string
  claimDetails?: ClaimDetail[]
  procedures: Procedure[]
  attachments: Attachment[]
}

export enum ClaimStatus {
  UnderReview = 'Under Review',
  Approved = 'Approved',
  Rejected = 'Rejected',
  PartiallyApproved = 'Partially Approved',
  Cancelled = 'Cancelled',
}

export type SelectedPatient = {
  id: number
  name: string
  address: PatientAddress
  photo: string
  claimDetails: ClaimDetail[]
  procedures?: Procedure[]
  claimForm?: string
  claimType?: ClaimType
  date?: string
}

export enum ClaimType {
  Standard = 'Standard Claim',
  ADA_2025 = 'ADA 2025',
}

export type ClaimData = {
  id?: string
  date?: string
  patientName: string
  patientId: string
  memberName: string
  subscriberId: string
  insuranceProvider: string
  providerId: string
  groupNo: string
  groupId: string
  validity: string
  coverage: string
  claimForm: ClaimType
  claimType: ClaimType
  procedures: Procedure[]
  attachments: ClaimAttachment[]
  photo: string
  claimDetails: ClaimDetail[]
  patientAddress?: PatientAddress
  clinicName?: string
  providerName?: string
  groupName?: string
  status?: ClaimStatus
  amountPaid?: number
}

export type DetailsTabProps = {
  selectedPatient: SelectedPatient | null
  onPatientSelect: (patient: SelectedPatient) => void
}

export type UpdateClaimThunkParams = {
  id: string
  body: Claim
}
